export const DEV_URL = 'https://mdev.pilottrading.co';
export const PROD_URL = 'https://mercury.pilottrading.co';
export const currentEnv = DEV_URL; //dev or prod

export const SignupTabs = {};
SignupTabs[(SignupTabs['key'] = 0)] = 'key';
SignupTabs[(SignupTabs['paylux'] = 1)] = 'paylux';
SignupTabs[(SignupTabs['trial'] = 2)] = 'trial';

export const MAX_DATE = new Date('9999-12-31T23:59:59').toLocaleDateString();
